import React from 'react';
import BaseView from '../../components/CRUDView';
import {FBOEndpoints, USSDEndpoints} from "../../common/ProxyEndpoints";
import {Permissions} from "../../common/Constants";
import AppVariables from '../../common/AppVariables';
import {renderStatus as StatusRender, TimeRangeInfo, TimeRangeSelectionDialog} from '../Request/RequestCommon';
import {CustomAcreageFilters, DetailView, getAcreageFilters, parseAcreageFilters, SearchProps} from "./AcreageCommon";
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import RequestStatisticsDialog from "../Request/RequestStatisticsDialog";
import Utils from "../../common/Utils";
import TractorRequestBuilder from "../../components/TractorRequestBuilder/TractorRequestBuilder";
import _ from "lodash";
import {getStatusFiltersForRole, RequestStatusFilter} from "../Request/RequestStatusConfiguration";
import EventListener from "../../common/EventListener";
import EventActions from "../../common/Events/Actions";


/**
 * Shows the acreage info for FBO
 */
class AcreageFBO extends BaseView {

    constructor(props){
        super(props,"fbo_requests");
        this.onRequestUpdate = this.onRequestUpdate.bind(this);
    }

    onRequestUpdate(){
        return this.refresh();
    }

    onExecuteRequest(url,params,{ filters }){

        const qs = params.query || (params.query = {});
        const {
            timeFrame,
            timeRangeStart,
            timeRangeEnd,
            status,
            requestType
        } = filters;

        if(!_.isNil(status)){

            const frame = RequestStatusFilter.find(x => x.value === status);
            if(frame && _.isFunction(frame.onApply)){
                frame.onApply(params);
            }

        }

        if(!_.isNil(requestType)){
            qs.request_type = requestType;
        }

        if(timeFrame){

            qs.request_filter_time_range = timeFrame;

            if(timeRangeStart) {
                qs.request_range_from = timeRangeStart.toJSON();
            }

            if(timeRangeEnd)
                qs.request_range_to = timeRangeEnd.toJSON();
        }

    }

    /**
     * Sets the time range to display
     */
    setTimeRangeDisplay(opts){

        const _update = {
            timeFrame: opts.range,
            timeRangeStart: opts.start ? opts.start.toJSON() : null,
            timeRangeEnd: opts.end ? opts.end.toJSON() : null
        };

        //
        this.setQueryFiltersRaw(filters => ({ ...filters, ..._update }));
    }

    fetchUSSDServices(){

        const options = USSDEndpoints.getUSSDServices();
        return this.execReq(options,{
            include: [ "pricing" ]
        }).then(response => {
            return response.getPayload();
        });

    }

    loadState(){

        return this.fetchUSSDServices().then(services => {

            this.setStateSafe({
                ussdServices : services
            });

        });

    }

    getCustomFilterState(filters) {
        return parseAcreageFilters(filters);
    }

    beginShowCreate(){
        this._createRequestDlg.show();
    }


    componentWillMount(){

        const me = this;

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No requests available yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-tree',

            //  The title for the content frame
            pageTitle: 'Tractor Requests',

            //  The total number of items per page
            maxItemsPerPage: AppVariables.MaxItemsPerPage,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false,
            },

            hooks:{

                //  Called before every query to get items
                preQueryHook: null

            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create:{
                    enabled: false,
                },

                //  delete action options
                delete: {
                    enabled : false,
                },

                //  delete action options
                edit:{
                    enabled : false
                }

            },

            model: {
                include: [
                    'tractor' ,
                    'tractor_operator' ,
                    "service" ,
                    "farmer" ,
                    "transactions",
                    "payment_status"
                ]
            },

            queryActions: {
                endpoint: FBOEndpoints.getRequests(me.getProxy().getUserInfo().fbo.id).url
            },


            filters: Utils.excludeFilters(getAcreageFilters({ findServiceName: id => {

                    const services = me.state.ussdServices;
                    if(Array.isArray(services) && services.length > 0){
                        let svc = services.find(x => x.id == id);
                        return svc ? svc.name : undefined;
                    }

                }}),['tractor_operator.id','tractorOperatorName' , 'tractor.id' , 'tractorName' ]),

            renderCustomFilters: props => <CustomAcreageFilters fetchFarmers={params => ({
                                                                    ...FBOEndpoints.getFBOFarmers(me.proxy.getUserInfo().fbo.id),
                                                                    ...params
                                                                })}
                                                                {...props}/>,


            search:{

                //
                placeholder: 'Search here...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                properties: SearchProps
            },

            //  Defines actions for toolbox
            toolBox: [
                {  text : 'Make Request' , icon : 'fa fa-plus' , invoke: () => me.beginShowCreate() , position: 'right' , permissions: [ Permissions.Requests.Create ] },
                {  text : 'Refresh' , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {
                    text : 'Status',
                    icon: 'fa fa-signal',
                    invoke: (index) => {
                        me.updateQuery('status',getStatusFiltersForRole(me.proxy.getUserRole())[index].value)
                    },
                    position: 'right' ,
                    group : 'type-filter' ,
                    items: getStatusFiltersForRole(me.proxy.getUserRole()).map(x => x.text),
                    withPortal: true,
                    portalOptions: {
                        title: 'Select Request Status',
                        itemStyle: {
                            cursor: "pointer"
                        }
                    }
                },
                {  text : 'Service'  , icon : 'fa fa-filter' , invoke: (index) => { me.updateQuery('service.id', me.state.ussdServices[index].id ) }, position: 'right' , group : 'type-filter' ,
                    items: () => me.state.ussdServices ? me.state.ussdServices.map(x => x.name) : undefined,
                    withPortal: true,
                    portalOptions: {
                        title: 'Select a service filter',
                        itemStyle: {
                            cursor: "pointer"
                        }
                    }
                },
                {
                    text: '', icon: 'fa fa-calendar',   items: Object.keys(TimeRangeInfo).map(x => TimeRangeInfo[x].label), position: 'left' , style: { marginRight: 10 } , invoke: index => {

                        let timeFrame = Object.keys(TimeRangeInfo)[index];
                        if (timeFrame === "custom") {

                            const filters = this.getQueryFilters();

                            //  show dialog for selecting time range
                            this._timeRangeSelectionDlg.show({
                                start: filters.timeRangeStart,
                                end: filters.timeRangeEnd
                            });

                            //  prevent selection of item
                            return false;

                        } else {

                            this.setTimeRangeDisplay({
                                range: timeFrame
                            });

                        }

                    }
                },
                {
                    text: "Request Type",
                    invoke: (index) => {

                        switch (index) {
                            case 0:
                                me.updateQuery('requestType','hiring');
                                break;
                            case 1:
                                me.updateQuery('requestType','booking');
                                break;
                        }

                    },
                    items: [
                        <span><i className="fa fa-money"/> Hiring</span>,
                        <span><i className="fa fa-calendar"/> Booking</span>,
                    ]
                },
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:

                                const filters = this.getQueryFilters();
                                this._statsDlg.show(me.getQueryParams({  }),(endpoint,params) => {
                                    this.onExecuteRequest(endpoint,params,filters);
                                });

                                break;
                            case 1:
                                return  me.toggleCustomFilterVisibility();
                        }

                    }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className="fa fa-pie-chart"/> Compute Statistics</span>,
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }
            ],

            //  Inputs used in editing and creating items
            inputs: [],

            // Describes the columns present in the table
            columns : [
                {key: 'order_id' , label: 'ID' },
                {key: 'name', label: () => me.sortCol('Farmer Name','name'), mobile: true },
                {key: 'location', label: () => me.sortCol('Location','location') },
                {key: 'type' , label: 'Service Type', cell: (item,key) => item.service.name , mobile: true  },
                {key: 'hectares' , label: () => me.sortCol('Quantity','hectares') , cell: (item,key) => <span><NumberLabel value={item[key]}/> {`${item.service.unit_name}${Number(item[key]) > 1 ? 's' : '' }`}</span> },
                {key: "cost", label: () => me.sortCol("Cost","cost") , format: 'money' },
                {key: 'status' , label: 'Status' , cell : (item,key) => StatusRender(item), mobile: true },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                //  called to render the title of the dialog if defined
                renderTitle: (item) => {
                    return `Request Details ${item ? ` (${item.order_id})`: '' }`;
                },

                //  Indicates whether the dialog is larger
                large: true,

                //  called to render the display window content if defined
                customRender: (item) => (<DetailView request={item}
                                                     showCommission={false}
                                                     showFarmer={true}
                                                     showOperator={true}
                                                     showIncome={false}
                                                     toggle={() => this.toggleDialog()}
                                                     defaultCoordinate={AppVariables.DefaultMapCoordinates}/>),

                //  The properties to render in the details dialog
                properties: [],

                //  Called to render to footer for the details dialog
                renderFooter: null,

                //  Invoked before showing
                onShow: () => { }
            },

            //  Processors
            processors :{

            }
        });

        this.loadState();
    }


    renderDialogs(dialog) {

        const timeRangeInfo = this.state.timeRangeInfo || {};

        return <React.Fragment>

            {super.renderDialogs(dialog)}

            <TractorRequestBuilder ref={r => this._createRequestDlg = r}
                                   onBuildRequest={payload => {

                                       return {
                                          query: {
                                            fbo: this.proxy.getUserInfo().fbo.id
                                          }
                                       };

                                   }}
                                   fetchFarmers={params => (this.proxy.processRequest({
                                       ...FBOEndpoints.getFBOFarmers(this.proxy.getUserInfo().fbo.id),
                                       ...params
                                   }))}
                                   onRequestCreated={request => {

                                       //  refresh list
                                       this.refresh();

                                   }}/>

            <RequestStatisticsDialog ref={r => this._statsDlg = r}/>

            <TimeRangeSelectionDialog ref={r => this._timeRangeSelectionDlg = r}
                                      from={timeRangeInfo.start}
                                      to={timeRangeInfo.end}
                                      onApply={({ start , end }) => {

                                          this.setTimeRangeDisplay({
                                              range: "custom",
                                              start,
                                              end
                                          });

                                      }}/>
        </React.Fragment>

    }

    renderExtra() {
        return <EventListener events={EventActions.TractorRequestUpdate} onEvent={this.onRequestUpdate}/>
    }

}

export  default AcreageFBO;



// WEBPACK FOOTER //
// ./src/views/Acreage/AcreageFBO.js